import { isSportsCategoryPath } from '@/constants/soccer'

export const FEED_ORDERING = {
  RELEVANCE: '-relevance',
  CLOSING_SOON: 'bet_end_date',
}

/**
 * The sort a feed falls back to when the URL names none. Sports lists fixtures, which are
 * only worth reading in the order they close — the next match first; every other feed
 * leads with relevance. Shared so the server's first page, the client's fetch and the sort
 * control all open on the same answer.
 */
export function defaultFeedOrdering(pathname) {
  return isSportsCategoryPath(pathname) ? FEED_ORDERING.CLOSING_SOON : FEED_ORDERING.RELEVANCE
}
